module.exports = __webpack_public_path__ + "static/quitafecha-157efea35c29656be09a0e01e294cbe4.jpg";